import React from 'react';
import { Grid, IconButton, Tooltip, Typography } from '@material-ui/core';
import { AddBoxRounded } from '@material-ui/icons';

interface Props {
  title: string,
  onAdd: () => void,
  tooltip?: string,
  fields?: React.ReactNodeArray
}

const AddFieldSectionHeader: React.FC<Props> = ({
  title,
  onAdd,
  tooltip = "Add new",
  fields
}) => {
  const onClick = () => onAdd();

  return (
    <Grid container spacing={2} alignItems="flex-end">
      <Grid item xs={11}>
        <Typography variant="body1">{title}</Typography>
      </Grid>

      <Grid item xs={1}>
        <Tooltip title={tooltip}>
          <IconButton onClick={onClick}>
            <AddBoxRounded />
          </IconButton>
        </Tooltip>
      </Grid>

      {fields}
    </Grid>
  )
}

export default AddFieldSectionHeader;
